import { sessionStorage as ss } from '@netlify/app-auth'
import { Pane } from 'evergreen-ui'
import dynamic from 'next/dynamic'
import { useEffect } from 'react'

import Dock from '~/components/Dock'
import HudSheet from '~/components/HudSheet'
import { useStore } from '~/store/hooks'
import { messageGift } from '~/utils/messages'

const CableProvider = dynamic(() => import('~/components/CableProvider'), { ssr: false })

export default function Drawer() {
  const user = useStore(state => state.account.user)
  const toggles = useStore(state => state.hud.toggles)

  useEffect(() => {
    if (!toggles.open) {
      const preferMinimized = !!ss.get('netlify-cdp-dock-minimized')
      if (preferMinimized) {
        messageGift('MINI_VIEWPORT')
      }
    }

    document.addEventListener('keydown', e => {
      if ((e.metaKey || e.ctrlKey) && !e.shiftKey && !e.altKey && (e.key === '\\' || e.code === 'Backslash')) {
        messageGift('TOGGLE_UI')
      }
    })
  }, [])

  return (
    <>
      {user.id && <CableProvider />}
      <HudSheet />
      <Dock />
      {toggles.studio && (
        <Pane height={1} position="absolute" top={-1} width={1}>
          <canvas id="freezeframe" style={{ visibility: 'hidden' }} />
          <video height="1" id="preview" muted />
          <video id="final" loop muted style={{ background: 'black' }} width="100%" />
        </Pane>
      )}
    </>
  )
}
